import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthStore } from '@store/auth.facade';

const ANONYMOUS_URLS = [
  '/api/Auth/login',
  '/api/Client',
  '/api/User/newUser',
];

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const isAnonymous = ANONYMOUS_URLS.some(url => req.url.includes(url));
  if (isAnonymous) {
    return next(req);
  }

  const authStore = inject(AuthStore);
  const token = authStore.token();

  if (token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  return next(req);
};